




































































































import Vue from "vue"
import Datatable, {DatatableOptions, FilterContainer, IDatatable} from "@/components/datatable/Datatable.vue"
import {PickupDiff} from "@/model/entity/pickup-diff/pickup-diff"
import {IPickupDiffService, pickupDiffService} from "@/model/service/pickupdiff/pickupdiff-service"
import {FieldDescription} from "@/model/entity/field-descriptor"
import moment from "moment"
import NewCarorderForm from "@/components/new-carorder/NewCarorderForm.vue"
import {PickupDiffStatusEnum, pickupDiffStatusEnumList} from "@/model/enum/pickup-diff-status-enum"
import { FilterOptionEnum, filterOptionList } from "@/model/util/filter-option/filter-option-enum"
import filterOptions from "@/model/util/filter-option/filter-option"

interface Data {
  carorderService: IPickupDiffService
  carorder: PickupDiff
  options: DatatableOptions
  fields: FieldDescription[]
  filters: FilterContainer
  dialogVisible: boolean
  selectedPickupDiff?: PickupDiff | null
  selectedItems: PickupDiff[]
  pickupDiffStatusEnumList: PickupDiffStatusEnum[]
  filterOptionList: FilterOptionEnum[]
  option: FilterOptionEnum
}

export default Vue.extend({
  components: {
    Datatable, NewCarorderForm
  },
  mixins: [ filterOptions ],
  data(): Data {
    return {
      carorderService: pickupDiffService,
      carorder: new PickupDiff(),
      options: {
        operations: {}
      },
      fields: PickupDiff.getFieldDescriptionList(),
      filters: {
        pickupDate: [
          moment()
            .startOf("day")
            .toDate(),
          moment()
            .add(7, "days")
            .endOf("day")
            .toDate()
        ]
      },
      dialogVisible: false,
      selectedPickupDiff: null,
      selectedItems: [],
      pickupDiffStatusEnumList: pickupDiffStatusEnumList,
      option: filterOptionList[0],
      filterOptionList: filterOptionList
    }
  },
  methods: {
    getStatusI18n(status: number) {
      const statusEnum = this.pickupDiffStatusEnumList.find(statusEnum => statusEnum.value === status)
      if (exists(statusEnum)) {
        return statusEnum!.i18nKey
      }
      return this.pickupDiffStatusEnumList.find(statusEnum => statusEnum.name === "UNKNOWN")!.i18nKey
    },
    rowSelectable(item: PickupDiff) {
      return item.statusId !== 1008 && item.statusId !== 1009 && item.statusId !== 106 && item.statusId !== 105
    },
    showDetails(pickupDiff: PickupDiff) {
      this.dialogVisible = true
      this.selectedPickupDiff = pickupDiff
    },
    filterChange(dates: Date[]) {
      if (exists(dates)) {
        dates[0] = moment(dates[0])
          .startOf("day")
          .toDate()
        dates[1] = moment(dates[1])
          .endOf("day")
          .toDate()
      }
      if (!exists(this.filters.pickupDate)) {
        this.$set(this.filters, "pickupDate", dates)
      } else {
        this.filters.pickupDate = dates
      }
      const datatable = this.$refs.datatable as IDatatable
      datatable.refreshData()
    },
    cancel(pickupDiffs: PickupDiff[]) {
      const vm = this
      vm.startLoad()
      vm.carorderService
        .cancel(pickupDiffs)
        .then(response => {
          vm.endLoad()
          if (exists(response.data) && response.data instanceof Array) {
            const failedCancels = response.data.filter(res => res.code !== 0)
            if (failedCancels.length === 0) {
              vm.$message({
                message: vm.$t("carorder.cancel_success").toString(),
                type: "success"
              })
            } else {
              const errorMessage = failedCancels.reduce((accumulator, currentValue) => {
                  return accumulator += `<strong>${currentValue.dispref}:</strong><br>${currentValue.message}<br><br>`
                }
                , "")
              this.$message({
                dangerouslyUseHTMLString: true,
                message: errorMessage,
                type: "error",
                duration: 6000
              })
            }
          } else {
            vm.$error(vm.$t(response.data.message))
          }
        })
        .catch(error => {
          vm.endLoad()
          vm.$error(error.message)
        })
    },
    updateFilterOption(option: FilterOptionEnum) {
      switch (option.value) {
        case 1:
          this.$set(this.filters, "office", this.$store.getters.loggedUser.office.id)
          this.filters.employee = ""
          this.filters.company = ""
          break
        case 2:
          this.$set(this.filters, "employee", this.$store.getters.loggedUser.username)
          this.filters.office = ""
          this.filters.company = ""
          break
        case 3:
          this.$set(this.filters, "company", this.$store.getters.loggedUser.office.company.id)
          this.filters.office = ""
          this.filters.employee = ""
          break
      }
      const datatable = this.$refs.datatable as IDatatable
      datatable.refreshData()
    }
  },
  created() {
    this.$nextTick(() => this.updateFilterOption(this.option))
  }
})
